  import { isEmpty, forEach, toLower } from 'lodash';
  import moment from 'moment';

  class FormValidatorService {
    
    validate(value, validators){
      let errors = [];

      forEach(validators, (eachValidator) => {
        if(this[eachValidator]) {
          const validationError = this[eachValidator](value);
          if (validationError) {
            errors.push(validationError);
          }
        }
      });
      // when there is no validation error pushing blank obj as sign of success
      errors.push({});
      return errors;
    }
    
    required(value){ 
      if(isEmpty(value)){
        return {required: true};
      } 
      else {
        if(value.replace(/\s/g, '').length === 0){
          return {required: true};
        }else{
          return null;
        }
      }
    }

    alphaStringWithSpaceBetween(value) {    
      return (!/^[a-zA-Z]+(\s*[-a-zA-Z]+)*$/.test(value)) ?
       {alphaStringWithSpaceBetween: true} :
      null;
    }

    zipCode(value){
        return (!/^[0-9]{5}?$/.test(value)) ? {zipCodeInvalid: true}:null;  
    }

    profileFileType(files) { 
      const fileTypesAllowed = ['.pdf', '.jpeg', '.jpg', '.png', '.webp'] ;
      if(!files.length) {
        return {profileFileTypeMismatch: true};
      } 
     return (new RegExp('(' + fileTypesAllowed.join('|').replace(/\./g, '\\.') + ')$')).test(toLower(files[0].name)) ? null :  {profileFileTypeMismatch: true};
    }

    validDate({day, month, year}) {
      return moment(`${year} ${month} ${day}`, "YYYY MM DD").isValid() ? null :{ validDate: true}
    }

    fiveYearPriorDate({day, month, year}) {
      const fiveYearPriorDate = moment().subtract(5, 'years')
      return moment(`${year} ${month} ${day}`).isBefore(fiveYearPriorDate)
       ? null :{ fiveYearPriorDate: true}
    }

    fileSizeCheck(files) {
      return (files.length && files[0].size/1024/1024 > 3) ? {fileSizeCheck: true} : null;
    }

    emptyFileCheck(files) {
      return (files.length &&  files[0].size === 0) ? {emptyFileCheck: true} : null;
    }
  
  
  }
  
  const instance = new FormValidatorService();
  Object.freeze(instance);
  
  export default instance;